export function createQuery(host, type, terms, durationStart = "-60m", durationEnd = "0m", durationInterval = "5m") {
     var qryTerms = "";
     var i=0;
    if(type === 'snmp'){
          
            for ( i; i<terms.length; i++) {
                if (qryTerms.length > 0) qryTerms += " or "
                qryTerms += 'r["_field"] == "' + terms[i] + '"'
            }
            return `from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["_measurement"] == "snmp")
            |> filter(fn: (r) => ${qryTerms})
            |> filter(fn: (r) => r["agent_host"] == "${host}")
            |> aggregateWindow(every: ${durationInterval}, fn: mean, createEmpty: true)
            |> yield(name: "mean")
            `
    }
    else {
         
            for ( i; i<terms.length; i++) {
                if (qryTerms.length > 0) qryTerms += " or "
                qryTerms += 'r["_field"] == "' + terms[i] + '"'
            }
            return `from(bucket: "telegraf")
            |> range(start: ${durationStart}, stop: ${durationEnd})
            |> filter(fn: (r) => r["host"] == "${host}")
            |> filter(fn: (r) => 
                r["_measurement"] == "ezelink_load_longterm" or 
                r["_measurement"] == "ezelink_load_midterm" or 
                r["_measurement"] == "ezelink_load_shortterm"
            )
            |> map(fn: (r) => ({
                r with
                qryTerms: if r._measurement == "ezelink_load_longterm" then "longterm"
                        else if r._measurement == "ezelink_load_midterm" then "midterm"
                        else if r._measurement == "ezelink_load_shortterm" then "shortterm"
                        else "unknown",
            }))
            |> aggregateWindow(every: ${durationInterval}, fn: max, createEmpty: true)
            |> drop(columns: ["qryTerms"])
            |> yield(name: "max")
            `
    }
}